import React from "react";
import "./shoppingcartpromo.scss";
import {
    CustomAccordian,
    ModalPopup,
} from "../../CommonComponent";
import Applycredit from "./ApplyCredit";
import { IContainerProps } from "./shoppingcartpromointerface";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import Loader from "../../Loader";
import ItemSummary from "./ItemSummary";
import Promo from "./Promo";
import EstimateShipping from "./EstimateShipping";
import helperfunctions from "../../../utils/helperfunctions";
import { useSelector } from "react-redux";
import { selectors as headerSelector } from '../../../state/features/header';
import {
    selectors as orderTrackingSelector
} from "../../../state/features/orderdetail";
import { IAppContextProps } from "../../App/AppInterface";
import { useAppContext } from "../../App/App";

const ShoppingCartPromo = (props: IContainerProps) => {
    const { t } = useTranslation();
    const { isMiningDistributor }: IAppContextProps = useAppContext();
    const itemSummaryObject = {
        title: t(RESOURCE.MyK_Label_ShoppingCart_Promo_Item_Summary),
        content: (
            <ItemSummary
                getItemSummaryDetails={props?.getItemSummaryDetails}
                itemSummaryDetails={props?.itemSummaryDetails}
                onViewDiscountDetails={props?.onViewDiscountDetails}
            />
        ),
        collapse: props?.collapseAll,
    };

    const promoObject = {
        title: t(RESOURCE.MyK_Label_ShoppingCart_Promo),
        content: (
            <Promo
                showPartCreditWhenPromoApplied={props?.showPartCreditWhenPromoApplied}
                isPromoCodeChangeUpdate={props?.isPromoCodeChangeUpdate}
                itemSummaryDetails={props?.itemSummaryDetails}
                getItemSummaryDetails={() => props?.getItemSummaryDetails()}
                isCheckoutButton={props?.isCheckoutButton}
                getCartItems={props?.getCartItems}
            />
        ),
        collapse: props?.collapseAll,
    };

    const estShipppingObject = {
        title: t(RESOURCE.MyK_Label_ShoppingCart_Promo_Estimate_Shipping),
        content: (
            <EstimateShipping
                togglePopupClick={() => props?.togglePopupClick()}
                estShipping={props?.estShipping}
                shippingCost={props?.itemSummaryDetails?.data?.shippingCost}
                itemSummaryDetails={props?.itemSummaryDetails?.data}
                cartsDetails={props?.cartsDetails}
                getItemSummaryDetailsWithoutLoading={props?.getItemSummaryDetailsWithoutLoading}

            />
        ),
        collapse: props?.collapseAll,
    };

    const { headercurrentuser,
        enableOrderTracking,
        enablePartOrdering
     }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
            enableOrderTracking: orderTrackingSelector.enableOrderTracking(state),
             enablePartOrdering: orderTrackingSelector.enablePartOrdering(state)
        })
        );

    const getCustomerCheckoutEnabled = () => {
        return (headercurrentuser?.userClaims?.includes("myKomatsu-Parts-ShoppingCart-CheckOut") || headercurrentuser.isAdmin)
    }

    const getPartsCreditEnabled = () => {
        return ((props?.userRoleType.toLowerCase() === 'customer' || (props?.userRoleType.toLowerCase() === 'distributor' && isDistributorAdmin) || props?.userRoleType.toLowerCase() === 'employee' || props?.userRoleType.toLowerCase() === 'company'));
    }

    const getCheckoutDisabled = () => {
        return (((!(props?.cartsDetails?.cart?.cartId > 0 && props?.itemSummaryDetails?.data?.subtotal > 0 && (headercurrentuser?.isGuestUser || (enablePartOrdering && isCustomerCheckoutEnabled)))) || (isMiningDistributor)));
    }
    const isCustomerCheckoutEnabled = getCustomerCheckoutEnabled();
    const isDistributorAdmin = headercurrentuser?.userClaims?.includes("Administration-Distributor-AdminRole");
    const toggleTitle = props?.collapseAll ? t(RESOURCE.MyK_Label_ShoppingCart_Promo_Close_All) : t(RESOURCE.MyK_Label_ShoppingCart_Promo_Expand_All)
    const isPartsCreditEnabled = getPartsCreditEnabled();
    const availableCreditAmount = helperfunctions.formatAmount(props?.customerCreditInfo?.data?.remainingCredit);
    const isCheckOutDisabled = getCheckoutDisabled();
    const isPunchOutDisabled = (props?.cartsDetails?.parts?.length ?? 0) <= 0;
    const isSeeRecommendationsDisabled = !(props?.cartsDetails?.parts?.length);
    const convertToNumber = (input: any) => {
        const number = input ? Number(input) : 0;
        return number;
    };

    const subTotal = convertToNumber(props?.itemSummaryDetails?.data?.subtotal);
    const discountTotal = convertToNumber(props?.itemSummaryDetails?.data?.discountTotal);
    const creditApplied = convertToNumber(props?.itemSummaryDetails?.data?.komatsuCredit);
    const total = convertToNumber(props?.itemSummaryDetails?.data?.total);
    const availableCredit = convertToNumber(props?.customerCreditInfo?.data?.remainingCredit)
    const { isPromoCodeApplied, isKomatsuCreditApplied } = props?.itemSummaryDetails?.data ?? {};
    const isPromoAppliedOrCreditAvailable = (isPromoCodeApplied || isKomatsuCreditApplied);
    const isDisableCredit = !availableCredit || !props?.cartsDetails?.parts?.length
    return (
        <div className="promo-wrapper">
            {props?.isPunchOutScreentUrl?.loading && <Loader />}
            <div className="promo-info float-right mb-2" title={toggleTitle} onKeyDown={() => { }} onClick={() => props?.toggleClick()}>
                {toggleTitle}
            </div>
            <div className="clearfix">
                <div className="itemSummaryContainer">
                    <CustomAccordian {...itemSummaryObject} />
                </div>
                {props?.userRoleType?.toLowerCase() !== "distributor" && <CustomAccordian {...promoObject} />}
                {enableOrderTracking && !props?.isPunchOutUser && <CustomAccordian {...estShipppingObject} />}
            </div>
            <div className="promo-Credit">
                <div className="promo-total">
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                            {(isPromoAppliedOrCreditAvailable) &&
                                <div className="totoalsec pl-0 pl-md-0 pl-lg-0 pr-xl-4">
                                    <div className='totoalsec_label mb-2'>{t(RESOURCE.MyK_Label_ShoppingCart_Promo_SubTotal)}</div>
                                    <div className={`value mb-2 ${(isPromoAppliedOrCreditAvailable) ? 'strike' : ''}`}>
                                        <span className={`value mb-2 ${(isPromoAppliedOrCreditAvailable) ? 'strike' : ''}`}>$</span>{`${helperfunctions.formatAmount(subTotal)}`}
                                    </div>
                                </div>}
                            {isPromoCodeApplied &&
                                <div className="totoalsec pl-0 pl-md-0 pl-lg-0 pr-xl-4">
                                    <div className="totoalsec_label mb-2">{t(RESOURCE.MyK_Label_ShoppingCart_Promo_Discount_Total)}</div>
                                    <div className="value mb-2 discount">
                                        <span className="value mb-2">-$</span>{`${helperfunctions.formatAmount(discountTotal)}`}
                                    </div>
                                </div>}
                            {(isPartsCreditEnabled && isKomatsuCreditApplied) &&
                                <div className="totoalsec pl-0 pl-md-0 pl-lg-0 pr-xl-4">
                                    <div className="totoalsec_label mb-2">{t(RESOURCE.MyK_Label_ShoppingCart_Parts_Credit_Applied)}</div>
                                    <div className="value mb-2">
                                        <span className="value mb-2">-$</span>{`${helperfunctions.formatAmount(creditApplied)}`}
                                    </div>
                                </div>}
                            <div className="totoalsec pl-0 pl-md-0 pl-lg-0 pr-xl-4">
                                <div className="totalValuelabel mb-2">{t(RESOURCE.MyK_Label_ShoppingCart_Total)}</div>
                                <div className="totalValue mb-2">
                                    <span className="totalValue">$</span>{`${helperfunctions.formatAmount(total)}`}
                                </div>
                            </div>
                            <div className="totoalsec_footer">
                                <div className="totalsecbutton_left">
                                    <div className="totalLabel">{t(RESOURCE.MyK_Label_ShoppingCart_Promo_Est_Pre_Tax_Total)}</div>
                                    <div className="totalLabel">{t(RESOURCE.MyK_Label_ShoppingCart_Promo_Excluding_Shipping)}</div>
                                </div>
                                <div className="totalsecbutton_right">
                                    {(props.isCheckoutButton && !props?.isPunchOutUser) &&
                                        <button
                                            disabled={isCheckOutDisabled}
                                            title={t(RESOURCE.MyK_Label_ShoppingCart_Promo_Checkout)}
                                            onClick={() => props?.onCheckOutClick()}
                                            className={`checkoutbtn ${isCheckOutDisabled ? 'disabled' : ''}`}>
                                            {t(RESOURCE.MyK_Label_ShoppingCart_Promo_Checkout)}
                                        </button>}
                                    {props?.isPunchOutUser && <button
                                            disabled={isPunchOutDisabled}
                                            title={t(RESOURCE.MyK_Label_ShoppingCart_Promo_Punchout)}
                                            onClick={() => props?.onPunchOutClick()}
                                            className={`checkoutbtn ${isPunchOutDisabled ? 'disabled' : ''}`}>
                                           {t(RESOURCE.MyK_Label_ShoppingCart_Promo_Punchout)}
                                        </button>}
                                   {props.isnextbutton &&
                                     <button
                                         title={t(RESOURCE.MyK_Label_ShoppingCart_Promo_Next)}
                                         onClick={() => props.handelNext()}
                                         disabled={props?.isDisableNext}
                                         className={`checkoutbtn nextbtn ${props.isDisableNext ? 'disabled' : ''}`}>
                                         {props?.isPlaceOrderButton ? t(RESOURCE.MyK_Label_ShoppingCart_Place_Order) : t(RESOURCE.MyK_Label_ShoppingCart_Promo_Next)}
                                     </button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-1 pl-3">
                <div
                    className={`cartLink ${isSeeRecommendationsDisabled ? 'disabled' : ''}`}
                    title={t(RESOURCE.MyK_Label_ShoppingCart_Promo_See_Recommendations_Based_on_Cart)}
                    onClick={() => props.productRecommendationPopupClick("")} onKeyDown={() => { }}>
                    {t(RESOURCE.MyK_Label_ShoppingCart_Promo_See_Recommendations_Based_on_Cart)}
                </div>
                {(isPartsCreditEnabled && !headercurrentuser.isGuestUser && !isDisableCredit) && <div
                    className={`creditLink ${isDisableCredit ? 'disabled' : ''}`}
                    title={t(RESOURCE.MyK_Label_ShoppingCart_Promo_Parts_Credit)}
                    onClick={() => props?.ApplyOnClick(true)} onKeyDown={() => { }}>
                    {t(RESOURCE.MyK_Label_ShoppingCart_Promo_Parts_Credit)}: ${availableCreditAmount} {t(RESOURCE.MyK_Label_ShoppingCart_Promo_Available)}
                </div>}
            </div>
            {
                props?.isapplycredit &&
                <ModalPopup
                    ModalPopupTitle={t(RESOURCE.MyK_Label_ShoppingCart_Promo_Apply_Credit)}
                    ModalPopupType="medium"
                    closeModalPopup={() => props?.partsCreditCancel(false)}>
                    <Applycredit
                        applyOnClick={() => props?.ApplyOnClick(false)}
                        availableCreditAmount={availableCreditAmount}
                        getItemSummaryDetails={() => props?.getItemSummaryDetails()}
                        getCustomerCreditInfo={props?.getCustomerCreditInfo}
                        customerCreditInfo={props?.customerCreditInfo}
                        itemSummaryDetails={props?.itemSummaryDetails}
                        onApplyClick={(creditDetails: any) => props?.onApplyClick(creditDetails)}
                        appliedCreditInfo={props?.appliedCreditInfo}
                        updateApplyCreditRes={props?.updateApplyCreditRes}
                        applyCreditResponse={props?.applyCreditResponse}
                        updateSelectedCredit={props?.updateSelectedCredit}
                        selectedCredit={props?.selectedCredit}
                    />
                </ModalPopup>
            }
        </div>
    );
};

export default ShoppingCartPromo;
